import { supabase } from '../../../lib/supabaseClient';
import type { ProcessBlueprintVersion } from '../../../types/processBlueprint';

export async function getVersionHistory(blueprintId: string, organizationId: string) {
  try {
    const { data, error } = await supabase
      .from('process_blueprint_versions')
      .select('*')
      .eq('blueprint_id', blueprintId)
      .eq('organization_id', organizationId)
      .order('version', { ascending: false });
    if (error) throw error;
    return (data ?? []) as ProcessBlueprintVersion[];
  } catch {
    return [] as ProcessBlueprintVersion[];
  }
}

export interface VersionDiff<T = Record<string, unknown>> {
  added: Partial<T>;
  removed: Partial<T>;
  changed: Partial<Record<keyof T, { from: unknown; to: unknown }>>;
}

export function compareVersions<T extends Record<string, unknown>>(a: T, b: T): VersionDiff<T> {
  const added: Partial<T> = {};
  const removed: Partial<T> = {};
  const changed: VersionDiff<T>['changed'] = {};

  Object.keys(b).forEach((key) => {
    const k = key as keyof T;
    if (!(k in a)) {
      added[k] = b[k];
    } else if (a[k] !== b[k]) {
      changed[k] = { from: a[k], to: b[k] };
    }
  });

  Object.keys(a).forEach((key) => {
    const k = key as keyof T;
    if (!(k in b)) {
      removed[k] = a[k];
    }
  });

  return { added, removed, changed };
}
